// @flow
import { useState, useCallback, useEffect } from 'react';

import { api } from 'app/api';
import { GET_REPORTS_DATA_PURCHASES_BY_PAYMENT_MODE } from 'app/common/api/requests/reports/data';

import type { ReportData } from './types';


export default function useReportData(reportId: ?number): [ReportData, boolean] {
  const [reportData, setReportData] = useState < ReportData >(null);
  const [loading, setLoading] = useState(true);

  const request = useCallback(async () => {
    if (!reportId) return;

    setLoading(true);
    const res = await api.request(GET_REPORTS_DATA_PURCHASES_BY_PAYMENT_MODE, {
      error: 'Не удалось загрузить данные отчета',
      params: {
        report_id: reportId,
      },
    });

    if (res) {
      setReportData(res);
    }
    setLoading(false);
  }, [reportId]);


  useEffect(() => {
    request();
  }, [request]);

  return [reportData, loading];
}
